// Module
var code = "<ng-include src=\"src\"></ng-include>";
// Exports
module.exports = code;